import styled from 'styled-components';

interface Props {
  problemInAccountB2B?: boolean;
}

export const AccountB2BContent = styled.div`
  display: flex;
  flex-direction: column;
  > div {
    margin-bottom: 20px;
  }
`;

export const AccountB2BInfo = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: solid 1px #e6e6e6;
  width: 100%;
  height: 100px;
  justify-content: space-around;
  > p {
    margin: 0 !important;
  }
`;

export const StatusAccountB2BInfo = styled.div<Props>`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
  display: flex;
  align-items: baseline;
  > span {
    align-self: center;
    margin-left: 10px;
    color: ${props => (props.problemInAccountB2B ? '#ED2A2A' : '#009A00')};
  }
`;
